// import React from 'react'
import Loadable from 'Components/LoadableToImported'
import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'

// import NearbyMapCta from './NearbyMapCta'

export const NearbyMapCta = Loadable({
  loader: () => import(/* webpackChunkName: "NearbyMapCta" */ './NearbyMapCta'),
  // loading,
  chunkName: 'NearbyMapCta',
})


const mapStateToProps = () => ({
})

const actions = {
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(NearbyMapCta)
